import React from "react";
import { FormControl } from "react-bootstrap";
import { i18n } from "../../app/i18n/i18n";
import { useDispatch } from "react-redux";
import { setPreference } from "components/Preferences/preferencesActions";

export const LanguageSelector = () => {
  const dispatch = useDispatch();

  return (
    <FormControl
      as="select"
      size="sm"
      onChange={(e) => onChange(e, dispatch)}
      defaultValue={i18n.getLanguage()}
      className="dropdown-menu-right text-white position-absolute border-0 bg-dark"
      style={{ top: 0, width: "200px", minWidth: "200px", textAlignLast: "right" }}
    >
      <option value="en">English (英語)</option>
      <option value="ja">日本語 (Japanese)</option>
    </FormControl>
  );
};

const onChange = (e, dispatch) => {
  e.preventDefault();
  const lang = e.target.value;
  dispatch(setPreference({ key: "grp-ui-lang", value: lang }));
};
